/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Actions from './Actions/index'
import CloseAction from './CloseAction/index'
import Fields from './Fields/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Address/Addresses/Content/Address/Edit/Content"
  
}) {
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
 width={400}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={0}
 level="h3"
 text="Edit Address"
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<Fields
  viewPath={`${viewPath}/Fields`}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}